import * as React from 'react';

interface PublicCMSLayoutProps {
  children: React.ReactNode;
}

export const PublicCMSLayout = ({ children }: PublicCMSLayoutProps) => {
  return (
    <div className="h-background--navy-200">
      <div className="h-container--small">{children}</div>
    </div>
  );
};
